import BookrunnerOverride from "./BookrunnerOverride";
class Bookrunner {
    name;
    names;
    override;
    partyId;
    roles;
    roleType;
    constructor(bookrunner) {
        this.name = bookrunner.name;
        this.names = bookrunner.names;
        this.override = bookrunner.override !== undefined ? new BookrunnerOverride(bookrunner.override) : undefined;
        this.partyId = bookrunner.partyId;
        this.roles = bookrunner.roles;
        this.roleType = bookrunner.roleType;
    }
    printName() {
        return this.name ?? this.names?.[0] ?? "";
    }
    isRealBookrunner() {
        const realBookrunners = ['ARRANGER', 'BOOK_RUNNER', 'GLOBAL_COORDINATOR', 'LEAD_BOOKRUNNER', 'LEAD_GLOBAL_COORDINATOR',
            'LEAD_MANAGER', 'LEAD_MANAGER_NO_BOOKS', 'LEAD_UNDERWRITER', 'MANAGER'];
        return this.roles?.some(r => realBookrunners.includes(r));
    }
}
export default Bookrunner;
